"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useStateForModel_1 = require("./useStateForModel");
exports.useValidation = function (fn, value) {
    var _a = react_1.useState({}), errors = _a[0], setErrors = _a[1];
    var _b = react_1.useState(true), isValid = _b[0], setIsValid = _b[1];
    var _c = useStateForModel_1.useStateForModel(value), model = _c[0], setModel = _c[1];
    var _d = react_1.useState({}), hasChanged = _d[0], setHasChanged = _d[1];
    react_1.useEffect(function () {
        var _hasChanged = __assign({}, hasChanged);
        var errors = Object.keys(model).reduce(function (last, current) {
            var error = fn(current, value[current], value);
            if (!error) {
                last[current] = '';
                _hasChanged[current] = true;
            }
            else {
                last[current] = !_hasChanged[current] ? '' : error;
            }
            if (!_hasChanged[current] && value[current] !== model[current]) {
                _hasChanged[current] = true;
                last[current] = error;
            }
            return last;
        }, {});
        setHasChanged(_hasChanged);
        var _isValid = !Object.keys(errors).some(function (x) { return errors[x]; }) && !Object.keys(model).some(function (x) { return !_hasChanged[x]; });
        setErrors(errors);
        setIsValid(_isValid);
    }, [value]);
    return [isValid, errors];
};
